module.exports = "<input class=\"<%= queryBox %>\"\r\n       type=\"text\"\r\n       ng-model=\"$ctrl.queryString\"\r\n       ng-change=\"$ctrl.makeQuery()\"\r\n       placeholder=\"{{ $ctrl.placeholderText }}\"\r\n>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/table/TableFilter/TableFilter.html
// module id = 594
// module chunks = 0